// eslint-disable-next-line import/prefer-default-export
export const handleNumericKeyPress = (event) => {
	const eventValue = event.key
	const inputType = event.target.type

	// Firefox handling
	// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/number#using_number_inputs
	if (inputType === 'number') {
		if (!/\d/g.test(eventValue)) {
			event.preventDefault()
		}
	}
}
